import { createFileRoute, redirect } from "@tanstack/react-router";
import { Callout } from "@/components/ui/callout";
import { FormPageSkeleton } from "@/components/app/skeletons";
import { useAuth } from "@/features/auth/store";
import { TransferPage } from "@/features/dispatch-stock-transfer/components/transfer-page";
import { errMsg, useTransfer } from "@/features/dispatch-stock-transfer/hooks";

export const Route = createFileRoute("/_app/dispatch/stock-transfer/$id")({
  beforeLoad: () => {
    if (!useAuth.getState().can("document.view")) throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const { id } = Route.useParams();
  const transfer = useTransfer(Number(id));
  if (transfer.isPending) return <FormPageSkeleton />;
  if (transfer.isError)
    return (
      <Callout tone="danger" title="Could not open this transfer">
        {errMsg(transfer.error)}
      </Callout>
    );
  // Re-seeded whenever the status moves, so the header state starts from what the server holds.
  return (
    <TransferPage
      key={`${transfer.data.id}-${transfer.data.status}`}
      transfer={transfer.data}
      facilityId={transfer.data.facilityId}
      plantName={transfer.data.facility?.name ?? null}
    />
  );
}
